import {RegistrationService} from "../../../services/registration-service";
import {useQuery} from "@tanstack/react-query";

export const useRegistrations = (panonId: string | undefined) => {
    const queryInfo = useQuery({
        queryKey: ['registrations', panonId],
        queryFn: () => RegistrationService.findRegistrationsByPanonId(panonId!),
        enabled: !!panonId,
    });

    return {
        ...queryInfo,
        registrations: queryInfo.data,
    };
};
